export const FieldType = {
	integer: 1,
	float: 2,
	string: 3,
	bool: 4,
	datetime: 5,
};
